import React from 'react';
import type { CmsNavigation } from '@gov-nx/api/cms/types';
import { isCmsNavigationService } from '@gov-nx/api/cms/types';
import type { LocalizeNameSpaceTypes } from '@gov-nx/core/service/translations/name-space.types';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { is } from '@gov-nx/core/types/helpers.types';
import { getPageUrlByCode } from '@gov-nx/module/page/definitions/PageMap';
import { getServiceUrlByCode } from '@gov-nx/module/service/definitions/ServiceMap';
import { TileLinkList } from '@gov-nx/ui/web/Tile/TileLinkList';

export interface CsmNavigationSignpostProps {
	navigations: CmsNavigation[];
	localizeNameSpace:
		| LocalizeNameSpaceTypes.Page
		| LocalizeNameSpaceTypes.Service;
}

export const CsmNavigationSignpost = ({
	navigations,
	localizeNameSpace,
}: CsmNavigationSignpostProps) => {
	const { t } = useLocale(localizeNameSpace);
	return (
		<section>
			<h2>{t('mozna-hledate')}</h2>
			<TileLinkList
				items={navigations
					.map((navigation) => {
						const link = isCmsNavigationService(navigation)
							? navigation.service
							: navigation.page;
						if (!link) {
							return null;
						}
						const route = isCmsNavigationService(navigation)
							? getServiceUrlByCode(navigation.service.code)
							: getPageUrlByCode(navigation.page.code);

						if (route?.indexOf('#') === -1) {
							return {
								label: link.name,
								link: route,
								icon: link.icon?.icon,
							};
						}
						return null;
					})
					.filter(is)}
			/>
		</section>
	);
};
